import {Injectable} from '@angular/core';
import {MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

import {PleaseWaitDialogComponent} from './please-wait-dialog.component';
import {Observable} from "rxjs";
import {Progression} from "@domain/progression/progression";

@Injectable()
export class PleaseWaitService {
    /**
     * Constructeur
     */
    constructor(private matDialog: MatDialog) {}

    /**
     * Affichage de la popup d'attente
     */
    show({ title,progression }: { title?: string,progression?: Observable<Progression> } = {}): MatDialogRef<PleaseWaitDialogComponent> {
        let matDialogRef: MatDialogRef<PleaseWaitDialogComponent>;

        //Ouverture de la popup
        matDialogRef = this.matDialog.open(PleaseWaitDialogComponent,{
            data: {
                title,
                progression
            },
            hasBackdrop: true,
            disableClose: true
        });

        return matDialogRef;
    }
}